import angular from 'angular';

var appUsersWebServices = angular.module('applicationModule.appUsersWebServices', []);

appUsersWebServices.factory('AppWebUsers', ['$state', 'Upload', 'AppWebUsersAPI', function ($state, Upload, AppWebUsersAPI) {
    'use strict';
    return {
        getList: function (appId, params) {
            return AppWebUsersAPI.getAppUsers(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        getDetail: function (appId, userId, type) {
            return AppWebUsersAPI.getUserDetail(appId, userId, type)
                .then(function (response) {
                    return response.data.detail[0];
                });
        },
        getSchema: function (appId) {
            return AppWebUsersAPI.getSchema(appId)
                .then(function (response) {
                    return response.data;
                });
        },
        get: function (userId, appId) {
            return AppWebUsersAPI.getUserInfo(userId, appId);
        },
        save: function (data, editMode) {
            if (editMode) {
                return AppWebUsersAPI.saveUserInfo(data);
            }

            return AppWebUsersAPI.insertUserInfo(data);
        },
        search: function (appId, text, users) {
            return AppWebUsersAPI.search(appId, text, users);
        },
        remove: function (userId, appId) {
            return AppWebUsersAPI.removeUser(userId, appId);
        },
        removeSelected: function (ids) {
            return AppWebUsersAPI.removeSelectedUser(ids);
        },
        importData: function (appId, file) {
            return AppWebUsersAPI.importData(appId, file);
        },
        getAttributes: function (appId) {
            return AppWebUsersAPI.getAttributes(appId);
        }
    };
}]);

appUsersWebServices.service('AppWebUsersAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';
    var API_URL = AppsoupAPI.API_URL + '/app/users-www/';

    this.getAppUsers = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };
    this.getSchema = function (appId) {
        return $http.get(API_URL + 'schema/' + appId);
    };
    this.getUserInfo = function (userId, appId) {
        return $http.get(API_URL + userId, {params: {application_id: appId}});
    };
    this.saveUserInfo = function (data) {
        return $http.put(API_URL + data.id, data);
    };
    this.insertUserInfo = function (data) {
        return $http.post(API_URL, data);
    };

    this.search = function (appId, text) {
        return $http.get(API_URL + 'search/' + appId + '/' + text);
    };

    this.removeUser = function (userId, appId) {
        return $http.delete(API_URL + 'delete/' + userId + '/' + appId);
    };
    this.removeSelectedUser = function (ids) {
        return $http.post(API_URL + 'delete-selected', {ids: ids});
    };
    this.getAttributes = function (appId) {
        return $http.get(API_URL + 'attributes/', {params: {application_id: appId}});
    };

    this.importData = function (appId, file) {
        return Upload.upload({
            url: API_URL + appId + '/import',
            method: 'POST',
            sendObjectsAsJsonBlob: false,
            fields: {},
            file: file
        });
    };
}]);

export default appUsersWebServices;
